export const DELIVERY_SUMMARY_VISIBILITY_NAME = 'deliverySummary';
export const MAIN_PAGE_CTA_VISIBILITY_NAME = 'mainPageCTA';

export interface DeliverySummaryImpression {
  event: 'custom_event';
  event_action: 'Impression';
  event_category: 'Delivery summary';
  event_label: 'not set';
}

export interface MainPageCTAImpression {
  event: 'custom_event';
  event_category: 'Product page CTA';
  event_action: 'Impression';
  event_label: string; // Text content of main page CTA
}

interface BasketTrackingItem {
  product_code: string;
  quantity: string;
  price_GBP: string;
}

export interface CartUpdateModalEvent {
  event: 'cart_update';
  ecommerce: {
    checkout: {
      basket_id: string;
      total_items_GBP: string;
      products: BasketTrackingItem[];
    };
  };
}

export interface InitialOpenCartModalEvent {
  ecommerce: null;
}

export interface CartModalContinueShopping {
  event: 'custom_event';
  event_action: 'Continue shopping click';
  event_category: 'Added to basket modal';
  event_label: 'not set';
}

export interface OnCartGoToBasketPayload {
  href: string;
}

export interface CartModalGoToBasket {
  event: 'custom_event';
  event_action: 'Basket click';
  event_category: 'Added to basket modal';
  event_label: 'not set';
  eventCallback: VoidFunction;
  eventTimeout: number;
}

export interface BuyGiftCard {
  event: 'custom_event';
  event_action: 'Buy giftcard';
  event_category: 'Product page';
  event_label: 'not set';
}
